package org.example.project.ui

import org.jetbrains.compose.resources.DrawableResource
import kotlinproject.composeapp.generated.resources.*

// --- NUR HIER DEFINIERT ---
data class AppLanguage(
    val code: String,
    val flagRes: DrawableResource,
    val name: String
)

val appLanguages = listOf(
    AppLanguage("DE", Res.drawable.flag_de, "Deutsch"),
    AppLanguage("EN", Res.drawable.flag_en, "English"),
    AppLanguage("ES", Res.drawable.flag_es, "Español"),
    AppLanguage("FR", Res.drawable.flag_fr, "Français"),
    AppLanguage("IT", Res.drawable.flag_it, "Italiano"),
    AppLanguage("SH", Res.drawable.flag_sr, "Srpski")
)

object L10n {
    const val DE = "DE"; const val EN = "EN"; const val FR = "FR"
    const val ES = "ES"; const val IT = "IT"; const val SH = "SH"

    val welcome = mapOf(DE to "Willkommen!", EN to "Welcome!", SH to "Dobrodošli!", FR to "Bienvenue!", ES to "¡Bienvenido!", IT to "Benvenuto!")
    val start = mapOf(DE to "Los geht's", EN to "Let's go", SH to "Idemo", FR to "C'est parti", ES to "Vamos", IT to "Andiamo")
    val difficultyLabel = mapOf(DE to "Schwierigkeitsgrad", EN to "Difficulty", SH to "Težina", FR to "Difficulté", ES to "Dificultad", IT to "Difficoltà")
    val easy = mapOf(DE to "Einfach", EN to "Easy", SH to "Lako", FR to "Facile", ES to "Fácil", IT to "Facile")
    val medium = mapOf(DE to "Mittel", EN to "Medium", SH to "Srednje", FR to "Moyen", ES to "Medio", IT to "Medio")
    val hard = mapOf(DE to "Schwer", EN to "Hard", SH to "Teško", FR to "Difficile", ES to "Difícil", IT to "Difficile")

    val modeSingle = mapOf(DE to "Allein spielen", EN to "Play Solo", SH to "Igraj sam", FR to "Jouer en solo", ES to "Jugar solo", IT to "Gioca da solo")
    val modeCreate = mapOf(DE to "Raum erstellen", EN to "Create Room", SH to "Napravi sobu", FR to "Créer un salon", ES to "Crear sala", IT to "Crea stanza")
    val modeJoin = mapOf(DE to "Beitreten", EN to "Join Room", SH to "Pridruži se", FR to "Rejoindre", ES to "Unirse", IT to "Partecipa")

    fun t(dict: Map<String, String>, lang: String): String = dict[lang] ?: dict[DE] ?: ""
}